import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { LoginService } from '../login/login.service';

@Component({
  selector: 'app-login',
  templateUrl: './app.login.component.html',
})
export class AppLoginComponent {


    busy = false;
    username = '';
    password = '';
    loginError = false;
    private subscription: Subscription = new Subscription();

    constructor(
      private route: ActivatedRoute,
      private router: Router,
      private loginService: LoginService
    ) {}


    ngOnInit(): void {
      this.subscription = this.loginService.user$.subscribe((x) => {
        if (this.route.snapshot?.url[0]?.path === 'login') {
          const accessToken = localStorage.getItem('access_token');
          const refreshToken = localStorage.getItem('refresh_token');
          if (x && accessToken && refreshToken) {
            const returnUrl = this.route.snapshot.queryParams['returnUrl'] || '';
            this.router.navigate([returnUrl]);
          }
        } // optional touch-up: if a tab shows login page, then refresh the page to reduce duplicate login
      });
    }
    login(): void {
      if (!this.username || !this.password) {
        return;
      }
      this.busy = true;
      const returnUrl = this.route.snapshot.queryParams['returnUrl'] || '';
      this.loginService
        .login(this.username, this.password)
        .pipe(finalize(() => (this.busy = false)))
        .subscribe(
          () => {
              if(returnUrl)
                this.router.navigate([returnUrl]);
            else
            this.router.navigateByUrl("/myargic");
          },
          () => {
            this.loginError = true;
          }
        );
    }

    ngOnDestroy(): void {
      this.subscription?.unsubscribe();
    }


}
